import { useSelector } from "react-redux"
import { RootState } from "../../store"
import { UserState } from "../../state/userSlice"
import { Disclosure, DisclosureButton, DisclosurePanel, Popover, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../style/common";
import Modal from "../Modal/Modal";
import LoginSignup from "./LoginSignup";
import { Fragment, useEffect, useState } from "react";
import { signOut } from "@firebase/auth";
import { auth } from "../../firebase";

const PROFILE_STORAGE_KEY = "materiahunter-profile-nav";

export type ProfileButtonProps = {
    onLinkClick: () => void
}

export function ProfileButton(props: ProfileButtonProps) {
    const {
        isLoggedIn
    } = useSelector<RootState, UserState>(x => x.user);

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const style = "fill-contrast-tertiary text-contrast-tertiary hover:bg-emphasis hover:text-emphasis-contrast hover:fill-emphasis-contrast group rounded-md p-2 text-sm leading-6 font-semibold flex gap-x-3 w-full";

    if (!isLoggedIn) {
        return <>
            <li>
                <button type="button" className={style} onClick={() => setIsLoginModalOpen(true)}>
                    <UserCircleIcon className="h-6 w-6 shrink-0" aria-hidden="true" />
                    <span className='font-normal'>Log In</span>
                </button>
            </li>

            <Modal isOpen={isLoginModalOpen} onOpenChange={setIsLoginModalOpen} title="" classNames={{ dialogPanel: "!w-[400px] !bg-primary" }}>
                <LoginSignup onLogin={() => setIsLoginModalOpen(false)} />
            </Modal>
        </>
    }

    return (
        <>
            <Disclosure as="div" defaultOpen={false} key={`profile-nav`}>
                {({ open }) => {
                    localStorage.setItem(PROFILE_STORAGE_KEY, `${open}`);

                    return (
                        <>
                            <DisclosureButton
                                className='flex items-center justify-between w-full text-left rounded-md p-2 gap-x-3 text-sm leading-6 font-semibold fill-contrast-tertiary text-contrast-tertiary hover:bg-emphasis hover:text-emphasis-contrast hover:fill-emphasis-contrast'
                            >
                                <div className='flex space-x-3'>
                                    <UserCircleIcon className="h-6 w-6 shrink-0" aria-hidden="true" />
                                    <span>Profile</span>
                                </div>
                                <ChevronRightIcon
                                    className={classNames(
                                        open ? 'rotate-90' : '',
                                        'h-6 w-6 shrink-0'
                                    )}
                                    aria-hidden="true"
                                />
                            </DisclosureButton>
                            <DisclosurePanel as="ul" className="mt-1 pr-2">
                                <li>
                                    <Link to={"/settings"} className={style} onClick={props.onLinkClick}>
                                        <span className='pl-9 font-normal'>Settings</span>
                                    </Link>
                                </li>
                                <li>
                                    <Popover className="relative">
                                        {({ open, close }) => (
                                            <>
                                                <Popover.Button className={style}>
                                                    <span className="pl-9 font-normal">Log Out</span>
                                                </Popover.Button>

                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-200"
                                                    enterFrom="opacity-0 translate-y-1"
                                                    enterTo="opacity-100 translate-y-0"
                                                    leave="transition ease-in duration-150"
                                                    leaveFrom="opacity-100 translate-y-0"
                                                    leaveTo="opacity-0 translate-y-1"
                                                >
                                                    <Popover.Panel className="!z-50 fixed"
                                                    >
                                                        <div className="w-screen max-w-xs flex-auto overflow-hidden rounded-lg bg-secondary text-sm leading-6 shadow-lg border border-color-border text-contrast-primary">
                                                            <div className="group relative flex flex-col rounded-lg">
                                                                <button
                                                                    onClick={() => {
                                                                        signOut(auth);
                                                                        close();
                                                                    }}
                                                                    className="font-semibold hover:bg-tertiary p-4"
                                                                >
                                                                    Confirm Logout
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </Popover.Panel>
                                                </Transition>
                                            </>
                                        )}
                                    </Popover>
                                </li>
                            </DisclosurePanel>
                        </>
                    )
                }}
            </Disclosure>
        </>
    )
}